import { Dialog } from '@angular/cdk/dialog';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { InformationModalComponent } from '../../components/modals/information-modal/information-modal.component';
import {
  JoinGroupModalComponent,
  JoinGroupModalType,
} from '../../components/modals/join-group-modal/join-group-modal.component';
import { JoinCompanyService } from '../../services/join-company.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { loadingProfile } from '../../stores/profile/profile.actions';
import { selectProfileData } from '../../stores/profile/profile.selector';
import { LoadingState } from '../../stores/store.states';

@Component({
  selector: 'app-join',
  templateUrl: './join.component.html',
  styleUrls: ['./join.component.scss'],
  standalone: false,
})
export class JoinComponent {
  fail: boolean = false;
  constructor(
    private dialog: Dialog,
    private localStorageService: LocalStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private joinCompanyService: JoinCompanyService,
    private auth: AuthService,
    private store: Store,
  ) {
    this.route.params.pipe(take(1)).subscribe((params) => {
      this.saveInviteLinkToLocalStorage(
        atob(
          this.joinCompanyService.reversURLFriendlyBase64Text(params['link']),
        ),
      );
      if (this.auth.isAuthenticated()) {
        this.store.dispatch(loadingProfile());
        this.store
          .select(selectProfileData)
          .pipe(
            filter(
              (profile) =>
                profile.quantumProfileLoadingState === LoadingState.SUCCESS,
            ),
            take(1),
          )
          .subscribe((profile) => {
            if (profile.completed) {
              this.openInviteDialog();
            } else {
              this.router.navigate(['/progress']);
            }
          });
      } else {
        this.openInformationDialogToLoginOrRegister();
      }
    });
  }
  openInformationDialogToLoginOrRegister() {
    const dialogRef = this.dialog.open(InformationModalComponent, {
      data: {
        headerText: 'Getting Started: Login or Create an Account',
        bodyText:
          "It seems like you're not logged in or don't have an account yet. Press 'OK' to log in or register, and then you can proceed with the invitation.",
      },
    });
    dialogRef.closed.subscribe((_) => {
      this.router.navigate(['/']);
    });
  }
  openInviteDialog() {
    const dialogRef = this.dialog.open<JoinGroupModalType>(
      JoinGroupModalComponent,
    );
    dialogRef.closed.subscribe((result) => {
      if (!!result && result.isValid) {
        this.joinCompanyService.joinCompany(result.joinLink).subscribe({
          next: (joinResult) => {
            this.localStorageService.removeInviteLinkFromLocalStorage();
            this.router.navigate(['/profile/company']);
          },
          error: (error) => {
            console.log('err', error);
            this.fail = true;
          },
        });
      } else if (!!result && !result?.isValid) {
        this.fail = true;
      } else {
        this.localStorageService.removeInviteLinkFromLocalStorage();
        this.router.navigate(['/profile/company']);
      }
    });
  }

  private saveInviteLinkToLocalStorage(link: string) {
    this.localStorageService.saveInviteLinkToLocalStorage(link);
  }
}
